<template>
  <el-card class="settings-card">
    <div class="setting-card-wrap">
      <img
        class="card-avatar"
        :src="config.image">
      <div class="setting-card-inner">
        <div class="setting-card-header">
          <span>{{ config.title }}</span>
          <slot></slot>
        </div>
        <div class="setting-card-info">{{ config.info }}</div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'SettingsCard',
  props: {
    config: Object
  }
}
</script>
<style lang="stylus" scoped>
.settings-card {
  // width: 320px;
  margin: 10px;

  .setting-card-wrap {
    display: flex;

    .card-avatar {
      flex: 0 0 42px;
      width: 42px;
      height: 42px;
    }

    .setting-card-inner {
      margin-left: 10px;
      flex: 1;

      .setting-card-header {
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
      }

      .setting-card-info {
        color: #999;
        font-size: 14px;
      }
    }
  }
}
</style>
